/* global $ */
import React, { useState, useEffect, useRef } from 'react';
import axiosInstance from "../axiosInstance";
import Swal from "sweetalert2";
import { useParams } from "react-router-dom";
import Footer from '../components/Footer';

function Permission() {
    const { userId } = useParams();
    const [modules, setModules] = useState([]);
    const [permissions, setPermissions] = useState({});
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const [modulesRes, userPermsRes] = await Promise.all([
                    axiosInstance.get("/permission/modules/list"),
                    axiosInstance.get(`/permission/${userId}`),
                ]);

                console.log("Modules API response:", modulesRes.data);
                console.log("User permissions API response:", userPermsRes.data);

                // Always unwrap the `data` field
                const modulesData = modulesRes.data?.data || [];
                const userPermsData = userPermsRes.data?.data || [];

                setModules(modulesData);

                // Convert array of db perms to object { moduleName: {...perms} }
                const permsObj = {};
                userPermsData.forEach((p) => {
                    permsObj[p.module_name] = {
                        can_create: p.can_create,
                        can_edit: p.can_edit,
                        can_delete: p.can_delete,
                        can_view: p.can_view,
                        can_export: p.can_export,
                        can_print: p.can_print,
                    };
                });

                setPermissions(permsObj);
            } catch (err) {
                console.error("Error loading permissions", err);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, [userId]);

    const handleChange = (module, field) => {
        setPermissions((prev) => ({
            ...prev,
            [module]: {
                ...prev[module],
                [field]: !prev[module]?.[field],
            },
        }));
    };

    const handleAllowAll = (module) => {
        const allEnabled = Object.values(permissions[module] || {}).every((v) => v);
        setPermissions((prev) => ({
            ...prev,
            [module]: {
                can_create: !allEnabled,
                can_edit: !allEnabled,
                can_delete: !allEnabled,
                can_view: !allEnabled,
                can_export: !allEnabled,
                can_print: !allEnabled,
            },
        }));
    };

    const handleSave = async () => {
        try {
            await axiosInstance.post(`/permission/${userId}`, permissions);
            alert("Permissions updated!");
        } catch (err) {
            console.error("Error saving permissions", err);
            alert("Failed to save permissions.");
        }
    };

    if (loading) return <p>Loading...</p>;

    return (
        <div className="page-wrapper">
            <div className="content container-fluid">
                <div className="page-header">
                    <div className="content-page-header">
                        <h5>User Permissions</h5>
                    </div>
                    <div className="role-testing d-flex align-items-center justify-content-between">
                        <h6>
                            User ID: <span className="ms-1">{userId}</span>
                        </h6>
                    </div>
                </div>

                {/* Table */}
                <div className="row">
                    <div className="col-sm-12">
                        <div className="card-table">
                            <div className="card-body">
                                <div className="table-responsive">
                                    <table className="table table-stripped table-hover">
                                        <thead className="thead-light">
                                            <tr>
                                                <th>#</th>
                                                <th>Module</th>
                                                <th>Create</th>
                                                <th>Edit</th>
                                                <th>Delete</th>
                                                <th>View</th>
                                                <th>Export</th>
                                                <th>Print</th>
                                                <th>Allow all</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {(modules || []).map((mod, index) => (
                                                <tr key={mod.name || index}>
                                                    <td>{index + 1}</td>
                                                    <td>{mod.label || mod.name}</td>
                                                    {[
                                                        "can_create",
                                                        "can_edit",
                                                        "can_delete",
                                                        "can_view",
                                                        "can_export",
                                                        "can_print",
                                                    ].map((field) => (
                                                        <td key={field}>
                                                            <label className="custom_check">
                                                                <input
                                                                    type="checkbox"
                                                                    checked={permissions[mod.name]?.[field] || false}
                                                                    onChange={() => handleChange(mod.name, field)}
                                                                />
                                                                <span className="checkmark"></span>
                                                            </label>
                                                        </td>
                                                    ))}
                                                    <td>
                                                        <label className="custom_check">
                                                            <input
                                                                type="checkbox"
                                                                checked={Object.values(
                                                                    permissions[mod.name] || {}
                                                                ).every((v) => v)}
                                                                onChange={() => handleAllowAll(mod.name)}
                                                            />
                                                            <span className="checkmark"></span>
                                                        </label>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                                <div className="btn-center my-4">
                                    <button
                                        type="button"
                                        className="btn btn-primary"
                                        onClick={handleSave}
                                    >
                                        Update Permissions
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* /Table */}
            </div>
        </div>
    );
}

export default Permission;
